import React from "react";
import { useTranslation } from "react-i18next";
import "./workexperience.css";
import { ReactComponent as Icon } from "../../icons/work-experience/chip.svg";

export default function Technologies({ technologies }) {
  const { t } = useTranslation();

  return (
    <div className="content-container">
      <h2 className="we-card-title">{t("experience.technologies")}</h2>
      <div className="technologies">
        {technologies.map(({ text, logo }) => (
          <picture key={text}>
            <img alt={text} src={`/images/technologies/${logo}`} />
            <tool-tip role="tool-tip">{text}</tool-tip>
          </picture>
        ))}
      </div>
      <div className="we-bg-icon we-bg-icon-large">
        <Icon />
      </div>
    </div>
  );
}
